// Resolves the API base URL.
//  - REACT_APP_API_URL, when set at build time, always wins (may be '' for same-origin).
//  - In production builds we default to '' (same origin) because the Express server
//    serves both the React build and /api on the same host (e.g. https://rothkenya.com).
//  - In development we default to the local Express dev port.
export const getApiBaseUrl = () => {
  const configuredUrl = process.env.REACT_APP_API_URL;
  if (configuredUrl !== undefined && configuredUrl !== null) {
    return configuredUrl.replace(/\/$/, '');
  }
  if (process.env.NODE_ENV === 'production') {
    return '';
  }
  return 'http://localhost:5004';
};

export const getApiUrl = (path) => `${getApiBaseUrl()}${path}`;
